function LoadingScreen() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-gray-50">
      <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-green-600" />
      <p className="text-sm text-gray-500">Cargando...</p>
    </div>
  );
}

export default LoadingScreen;
